export const ENABLE_MOBILE_GUIDE_REDIRECT = false;

export const ENABLE_EXTENDED_FEATURES = false;
